import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'antd';
import Grid from '@material-ui/core/Grid';

const WarningForIncompletedProfile = ({ page }) => {
  const message = useMemo(() => {
    if (page === 'tests') {
      return <p>Go to <b>Profile</b> and enter information about your Experience, Education, Skills etc..</p>;
    } else if (page === 'finalize-my-resume') {
      return <p>You have not unlocked this step yet!</p>;
    } else {
      return null;
    }
  }, page);

  return (
    <Grid item xs={12} sm={12} md={12} lg={12}>
      <div className="check-valid-msg">
        {message}
        <Icon type="lock" style={{ fontSize: '55px', paddingTop: '25px' }} />
      </div>
    </Grid>
  );
};

WarningForIncompletedProfile.defaultProps = {
  page: 'tests'
};

WarningForIncompletedProfile.propTypes = {
  page: PropTypes.string
};

export default WarningForIncompletedProfile;
